import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { IAppState } from 'config/redux/reducers';
import IStepsProgress, {
  StepsStatusType,
  EStepsStatus,
  EStepsProgress,
} from '../interfaces/stepsProgress.interface';
import useAction from 'hooks/useAction';
import { setStepStatus } from '../redux/actions/stepsProgress.action';

const getStatus = (prevStep: boolean, currentStep: boolean): StepsStatusType => {
  if (!prevStep) {
    return EStepsStatus.disabled;
  }

  if (prevStep && !currentStep) {
    return EStepsStatus.active;
  }

  return EStepsStatus.completed;
};

const checkIfEnabled = (prevStep: boolean, currentStep: boolean): boolean =>
  getStatus(prevStep, currentStep) !== EStepsStatus.disabled;

const useStepsProgress = (): [
  IStepsProgress,
  {
    getStatus: typeof getStatus;
    checkIfEnabled: typeof checkIfEnabled;
    // setStepStatusAction: typeof setStepStatus;
    setStepDeliverToStatus: (flag: boolean) => any;
    setStepShipmentsStatus: (flag: boolean) => any;
    setStepPaymentStatus: (flag: boolean) => any;
  }
] => {
  const { stepsProgress } = useSelector(({ checkout }: IAppState) => checkout);
  const [setStepStatusAction] = useAction(setStepStatus);

  const setStepDeliverToStatus = useCallback(
    (flag: boolean) => setStepStatusAction(EStepsProgress.deliverTo, flag),
    [setStepStatusAction]
  );

  const setStepShipmentsStatus = useCallback(
    (flag: boolean) => setStepStatusAction(EStepsProgress.shipments, flag),
    [setStepStatusAction]
  );

  const setStepPaymentStatus = useCallback(
    (flag: boolean) => setStepStatusAction(EStepsProgress.payment, flag),
    [setStepStatusAction]
  );

  return [
    stepsProgress,
    {
      getStatus,
      checkIfEnabled,
      // setStepStatusAction,
      setStepDeliverToStatus,
      setStepShipmentsStatus,
      setStepPaymentStatus,
    },
  ];
};

export default useStepsProgress;
